import {Dispatch} from 'redux';

import Types from '../Types';

import NetEpisodeCommentsRepository from '../../../data/repositories/writer/NetEpisodeCommentsRepository';

export default function action(
  id: number,
): (dispatch: Dispatch<any>) => Promise<number> {
  return async (dispatch: Dispatch<any>): Promise<number> => {
    try {
      await new NetEpisodeCommentsRepository().destroy(id);
      const payload = id;
      dispatch({payload, type: Types.DestroyEpisodeCommentSuccess});
      return payload;
    } catch (err) {
      dispatch({type: Types.DestroyEpisodeCommentFailure});
      throw err;
    }
  };
}
